// Main Product Custom JavaScript

// Lazy load Face API for product page (shared with previewer)
function loadFaceAPI() {
  return new Promise((resolve, reject) => {
    if (window.faceapi) { resolve(window.faceapi); return; }
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/@vladmandic/face-api@1/dist/face-api.js';
    script.onload = () => resolve(window.faceapi);
    script.onerror = reject;
    document.head.appendChild(script);
  });
}
window.loadFaceAPI = window.loadFaceAPI || loadFaceAPI;

// AJAX Variant Switching - Core Functions
// AJAX Variant Switching - Core Functions
window.VariantSwitcher = {
  // Find variant by SKU (matching the URL handle)
  findVariantBySku(sku) {
    if (!window.productVariants) return null;
    // Try exact match first
    let variant = window.productVariants.find(v => v.sku === sku);
    if (variant) return variant;

    // If not found, try case-insensitive
    return window.productVariants.find(v => v.sku && v.sku.toLowerCase() === sku.toLowerCase());
  },

  // Fetch product data from Shopify
  async fetchProductData(productUrl) {
    try {
      const response = await fetch(`${productUrl}.js`);
      if (!response.ok) throw new Error('Product not found');
      return await response.json();
    } catch (error) {
      console.error('Error fetching product data:', error);
      return null;
    }
  },

  // Update product prices on the page
  updatePrices(variant) {
    const currentPriceDisplay = document.getElementById('current-price-display');
    const comparePriceDisplay = document.getElementById('compare-price-display');

    if (currentPriceDisplay) {
      // Store base price for calculations with extras
      currentPriceDisplay.setAttribute('data-base-price', variant.price);

      // Update the display
      const formattedPrice = this.formatPrice(variant.price);
      currentPriceDisplay.textContent = formattedPrice;
    }

    // Update compare at price if exists
    if (comparePriceDisplay && variant.compare_at_price) {
      comparePriceDisplay.setAttribute('data-base-price', variant.compare_at_price);
      const formattedComparePrice = this.formatPrice(variant.compare_at_price);
      comparePriceDisplay.textContent = formattedComparePrice;
      comparePriceDisplay.style.display = '';
    } else if (comparePriceDisplay) {
      comparePriceDisplay.style.display = 'none';
    }

    // Trigger price update for extras (Express, Gift Note)
    if (window.updateAllPrices) {
      window.updateAllPrices();
    }
  },

  // Update product images
  updateImages(variant, product) {
    // Update main product image
    const mainImage = document.querySelector('.product__media-item img[data-product-image]');
    if (mainImage && variant.featured_image) {
      mainImage.src = variant.featured_image.src;
      mainImage.srcset = '';
      mainImage.alt = variant.featured_image.alt || (product ? product.title : document.title);
    }

    // Update thumbnail gallery if exists (only if product data is available)
    const thumbnails = document.querySelectorAll('.product__media-list img');
    if (thumbnails.length > 0 && product && product.images && product.images.length > 0) {
      thumbnails.forEach((thumb, index) => {
        if (product.images[index]) {
          thumb.src = product.images[index];
        }
      });
    }
  },

  // Update variant ID in form
  updateVariantId(variantId) {
    const variantInputs = document.querySelectorAll('.product-variant-id, input[name="id"]');
    variantInputs.forEach(input => {
      input.value = variantId;
      input.setAttribute('value', variantId);
    });
  },

  // Update availability
  updateAvailability(variant) {
    const addToCartButtons = document.querySelectorAll('button[name="add"]');
    const inventoryStatus = document.querySelector('.product__inventory');

    if (variant.available) {
      addToCartButtons.forEach(btn => {
        btn.disabled = false;
        btn.classList.remove('disabled');
      });
      if (inventoryStatus) {
        inventoryStatus.textContent = 'In Stock';
        inventoryStatus.classList.remove('out-of-stock');
      }
    } else {
      addToCartButtons.forEach(btn => {
        btn.disabled = true;
        btn.classList.add('disabled');
      });
      if (inventoryStatus) {
        inventoryStatus.textContent = 'Out of Stock';
        inventoryStatus.classList.add('out-of-stock');
      }
    }
  },

  // Format price using Shopify settings
  formatPrice(priceInCents) {
    const currencyCodeEnabled = window.SHOPIFY_CURRENCY_CODE_ENABLED || false;
    const currencySymbol = window.SHOPIFY_CURRENCY_SYMBOL || '';
    const currencyCode = window.SHOPIFY_CURRENCY_ISO_CODE || 'USD';

    if (currencyCodeEnabled) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(priceInCents / 100);
    } else {
      return (priceInCents / 100).toFixed(0) + ' ' + currencySymbol;
    }
  },


  showLoading() {
    const priceContainer = document.querySelector('.product-info__price');
    if (priceContainer) {
      priceContainer.style.opacity = '0.5';
      priceContainer.style.pointerEvents = 'none';
    }
  },

  // Hide loading state
  hideLoading() {
    const priceContainer = document.querySelector('.product-info__price');
    if (priceContainer) {
      priceContainer.style.opacity = '1';
      priceContainer.style.pointerEvents = 'auto';
    }
  },

  // Main switch function
  async switchToVariant(newUrl) {
    if (newUrl === window.location.pathname) return;

    this.showLoading();

    // Store current state of Express and Gift Message before switching
    const expressCheckbox = document.querySelector('#express-delivery, .express-delivery');
    const giftMessageCheckbox = document.querySelector('#gift-message-checkbox, .gift-message-checkbox');
    const giftMessageText = document.querySelector('#gift-message-text, .gift-message-text');

    const savedState = {
      express: expressCheckbox ? expressCheckbox.checked : false,
      giftMessage: giftMessageCheckbox ? giftMessageCheckbox.checked : false,
      giftMessageText: giftMessageText ? giftMessageText.value : ''
    };

    // Try local lookup first (using handle from URL as SKU)
    const handle = newUrl.split('/').pop();
    const localVariant = this.findVariantBySku(handle);

    if (localVariant) {
      // Found locally!
      this.updatePrices(localVariant);
      this.updateImages(localVariant, null); // No full product data needed for local switch
      this.updateVariantId(localVariant.id);
      this.updateAvailability(localVariant);

      this.restoreAddonState(savedState);

      const urlWithParams = this.buildUrlWithState(newUrl, savedState);
      history.pushState({ variantId: localVariant.id, ...savedState }, '', urlWithParams);

      this.hideLoading();
      return;
    }

    // Fallback: Fetch product data
    const productData = await this.fetchProductData(newUrl);

    if (!productData) {
      console.error('Could not load variant, falling back to redirect');
      // Build URL with query params for state persistence
      const urlWithParams = this.buildUrlWithState(newUrl, savedState);
      window.location.href = urlWithParams;
      return;
    }

    // Get the first variant (since each product URL represents a specific variant)
    const variant = productData.variants[0];

    // Update everything
    this.updatePrices(variant);
    this.updateImages(variant, productData);
    this.updateVariantId(variant.id);
    this.updateAvailability(variant);

    // Restore Express and Gift Message state
    this.restoreAddonState(savedState);

    // Update URL with query params to persist state
    const urlWithParams = this.buildUrlWithState(newUrl, savedState);
    history.pushState({ variantId: variant.id, ...savedState }, '', urlWithParams);

    this.hideLoading();

  },

  // Build URL with state query parameters
  buildUrlWithState(url, state) {
    const urlObj = new URL(url, window.location.origin);

    // Add query params only if they're true/non-empty
    if (state.express) {
      urlObj.searchParams.set('express', '1');
    }
    if (state.giftMessage) {
      urlObj.searchParams.set('gift_message', '1');
    }
    if (state.giftMessageText) {
      // URLSearchParams.set() handles encoding automatically
      urlObj.searchParams.set('message', state.giftMessageText);
    }

    return urlObj.pathname + urlObj.search;
  },

  // Restore addon checkboxes state
  restoreAddonState(state) {
    const expressCheckbox = document.querySelector('#express-delivery, .express-delivery');
    const giftMessageCheckbox = document.querySelector('#gift-message-checkbox, .gift-message-checkbox');
    const giftMessageText = document.querySelector('#gift-message-text, .gift-message-text');

    // Restore Express checkbox
    if (expressCheckbox && expressCheckbox.checked !== state.express) {
      expressCheckbox.checked = state.express;
      // Trigger change event to update UI
      expressCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Restore Gift Message checkbox
    if (giftMessageCheckbox && giftMessageCheckbox.checked !== state.giftMessage) {
      giftMessageCheckbox.checked = state.giftMessage;

      // If checking the gift message, manually show the textarea wrapper
      if (state.giftMessage) {
        const parent = giftMessageCheckbox.closest('.gift-message-field');
        let textareaWrapper = null;
        if (parent) {
          const nextSibling = parent.nextElementSibling;
          if (nextSibling && (nextSibling.classList.contains('gift-message-textarea-wrapper') || nextSibling.id === 'gift-message-textarea-wrapper')) {
            textareaWrapper = nextSibling;
          } else {
            const container = parent.closest('.additional-options-fields');
            if (container) {
              textareaWrapper = container.querySelector('#gift-message-textarea-wrapper, .gift-message-textarea-wrapper');
            }
          }
        }
        if (!textareaWrapper) {
          textareaWrapper = document.querySelector('#gift-message-textarea-wrapper, .gift-message-textarea-wrapper');
        }

        // Show textarea wrapper with animation
        if (textareaWrapper) {
          textareaWrapper.style.display = 'block';
          // Force reflow to ensure the transition works
          void textareaWrapper.offsetHeight;
          textareaWrapper.classList.add('active');
        }
      }

      // Trigger change event to update UI
      giftMessageCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Restore Gift Message text
    if (giftMessageText && state.giftMessageText) {
      // Small delay to ensure textarea is visible first
      setTimeout(() => {
        giftMessageText.value = state.giftMessageText;
      }, 100);
    }

    // Update prices with the restored state
    if (window.updateAllPrices) {
      setTimeout(() => window.updateAllPrices(), 50);
    }
  }
};

// Language handler with AJAX switching
document.addEventListener('DOMContentLoaded', function () {
  const allLanguageSelects = document.querySelectorAll('#story-language, .story-language');

  const currentUrl = window.location.pathname;

  allLanguageSelects.forEach(select => {
    // Initialize value based on URL
    if (currentUrl.includes('-ar')) {
      select.value = 'Arabic';
    } else if (currentUrl.includes('-de')) {
      select.value = 'German';
    } else if (currentUrl.includes('-sp')) {
      select.value = 'Spanish';
    } else if (currentUrl.includes('-it')) {
      select.value = 'Italian';
    } else if (currentUrl.includes('-fr')) {
      select.value = 'French';
    } else {
      select.value = 'English';
    }

    // Handle language change
    select.addEventListener('change', function (e) {

    });

    // Trigger change event to update UI buttons
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const giftBoxButtons = document.querySelectorAll('.gift-box-button');

  giftBoxButtons.forEach(button => {
    button.addEventListener('click', function (e) {
      // Prevent other listeners (like modern-option-button) from firing
      e.preventDefault();
      e.stopImmediatePropagation();

      // Find the input - prefer ID but fallback to name
      // Handle potential duplicate IDs or inputs by updating ALL matching inputs
      const allInputs = document.querySelectorAll('#gift-wrapping, [name="gift-wrapping"]');

      if (allInputs.length > 0) {
        // Use the first one as source of truth
        const primaryInput = allInputs[0];
        const isCurrentlySelected = primaryInput.value === 'Yes';
        const newValue = isCurrentlySelected ? 'No' : 'Yes'; // Toggle

        // Update ALL inputs
        allInputs.forEach(inp => inp.value = newValue);

        // Update ALL buttons (sync visual state)
        giftBoxButtons.forEach(btn => {
          if (newValue === 'Yes') {
            btn.classList.add('active');
          } else {
            btn.classList.remove('active');
          }
        });

        // Update prices immediately
        if (window.updateAllPrices) {
          window.updateAllPrices();
        }
      }
    });
  });
});

// Number of Pages handler (variant switcher, no URL changes)
document.addEventListener('DOMContentLoaded', function () {
  const allPagesSelects = document.querySelectorAll('#number-of-pages, .number-of-pages');
  if (!allPagesSelects.length) return;

  const pageButtons = document.querySelectorAll('.pages-button');
  const idInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
  const currentVariantId = idInput ? parseInt(idInput.value, 10) : null;
  const currentVariant = window.productVariants?.find(v => v.id === currentVariantId);

  const getPagesValueFromVariant = (variant) => {
    if (!variant || !variant.options) return null;
    if (variant.options.includes('12 Pages')) return '12';
    if (variant.options.includes('20 Pages')) return '20';
    return null;
  };

  const setButtonStates = (pagesValue) => {
    pageButtons.forEach(btn => {
      if (btn.getAttribute('data-pages-value') === pagesValue) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  };

  const selectVariantForPages = (pagesValue) => {
    const targetLabel = pagesValue === '12' ? '12 Pages' : '20 Pages';
    const variant = (window.productVariants || []).find(v => (v.options || []).includes(targetLabel));
    if (variant) {
      window.VariantSwitcher.updatePrices(variant);
      window.VariantSwitcher.updateImages(variant, null);
      window.VariantSwitcher.updateVariantId(variant.id);
      if (idInput) idInput.value = variant.id;
    }
  };

  // Initialize
  // Initialize
  let initialPages = '20';
  const urlParams = new URLSearchParams(window.location.search);
  const hasVariantParam = urlParams.has('variant');
  const defaultInput = document.getElementById('number-of-pages');

  if (hasVariantParam && currentVariant) {
    initialPages = getPagesValueFromVariant(currentVariant) || '20';
  } else if (defaultInput && defaultInput.value) {
    initialPages = defaultInput.value;
  } else {
    initialPages = getPagesValueFromVariant(currentVariant) || '20';
  }

  setButtonStates(initialPages);

  // If we decided on a default that differs from the loaded variant (and no URL param), switch to it
  if (!hasVariantParam && currentVariant && getPagesValueFromVariant(currentVariant) !== initialPages) {
    selectVariantForPages(initialPages);
  }
  allPagesSelects.forEach(select => {
    select.value = initialPages;
    select.addEventListener('change', function (e) {
      const pagesValue = e.target.value === '12' ? '12' : '20';
      setButtonStates(pagesValue);
      selectVariantForPages(pagesValue);
    });
  });

  pageButtons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const pagesValue = this.getAttribute('data-pages-value') === '12' ? '12' : '20';
      allPagesSelects.forEach(select => { select.value = pagesValue; });
      setButtonStates(pagesValue);
      selectVariantForPages(pagesValue);
    });
  });
});

// Initialize Express and Gift Message state from URL on page load
document.addEventListener('DOMContentLoaded', function () {
  // Parse URL query parameters
  const urlParams = new URLSearchParams(window.location.search);

  const expressParam = urlParams.get('express');
  const giftMessageParam = urlParams.get('gift_message');
  const messageParam = urlParams.get('message');

  // Restore Express Delivery state
  if (expressParam === '1') {
    const expressCheckbox = document.querySelector('#express-delivery, .express-delivery');
    if (expressCheckbox && !expressCheckbox.checked) {
      expressCheckbox.checked = true;
      // Trigger change event to update UI and price
      expressCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Restore Gift Message state
  if (giftMessageParam === '1') {
    const giftMessageCheckbox = document.querySelector('#gift-message-checkbox, .gift-message-checkbox');
    if (giftMessageCheckbox && !giftMessageCheckbox.checked) {
      giftMessageCheckbox.checked = true;

      // Manually show the textarea wrapper (same logic as the change event handler)
      const parent = giftMessageCheckbox.closest('.gift-message-field');
      let textareaWrapper = null;
      if (parent) {
        const nextSibling = parent.nextElementSibling;
        if (nextSibling && (nextSibling.classList.contains('gift-message-textarea-wrapper') || nextSibling.id === 'gift-message-textarea-wrapper')) {
          textareaWrapper = nextSibling;
        } else {
          const container = parent.closest('.additional-options-fields');
          if (container) {
            textareaWrapper = container.querySelector('#gift-message-textarea-wrapper, .gift-message-textarea-wrapper');
          }
        }
      }
      if (!textareaWrapper) {
        textareaWrapper = document.querySelector('#gift-message-textarea-wrapper, .gift-message-textarea-wrapper');
      }

      // Show textarea wrapper with animation
      if (textareaWrapper) {
        textareaWrapper.style.display = 'block';
        // Force reflow to ensure the transition works
        void textareaWrapper.offsetHeight;
        textareaWrapper.classList.add('active');
      }

      // Trigger change event to update UI and price
      giftMessageCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Restore message text if present
    if (messageParam) {
      // Wait for textarea to be visible
      setTimeout(() => {
        const giftMessageText = document.querySelector('#gift-message-text, .gift-message-text');
        if (giftMessageText) {
          // URLSearchParams.get() handles decoding automatically
          giftMessageText.value = messageParam;
        }
      }, 150);
    }
  }

  // Update prices after restoring state with retry mechanism
  if (expressParam === '1' || giftMessageParam === '1') {
    // Function to wait for price elements and updateAllPrices to be ready
    function waitAndUpdatePrices(attempts = 0) {
      const currentPriceDisplay = document.getElementById('current-price-display');
      const basePrice = currentPriceDisplay ? currentPriceDisplay.getAttribute('data-base-price') : null;

      // Check if updateAllPrices exists and base price is set
      if (window.updateAllPrices && basePrice && basePrice !== '0' && basePrice !== '') {
        window.updateAllPrices();
      } else if (attempts < 20) {
        // Retry after 100ms, max 20 attempts (2 seconds total)
        setTimeout(() => waitAndUpdatePrices(attempts + 1), 100);
      } else {
        console.warn('Could not update prices - base price not ready');
      }
    }

    // Start checking after initial delay
    setTimeout(() => waitAndUpdatePrices(), 200);
  }
});

// Modern Option Buttons - Handle button clicks and sync with checkboxes
document.addEventListener('DOMContentLoaded', function () {
  // Handle all modern option buttons
  const modernButtons = document.querySelectorAll('.modern-option-button');

  modernButtons.forEach(button => {
    // Find the associated checkbox
    let checkbox;
    const checkboxId = button.getAttribute('data-checkbox-id');
    const checkboxClass = button.getAttribute('data-checkbox-class');

    if (checkboxId) {
      checkbox = document.getElementById(checkboxId);
    } else if (checkboxClass) {
      const parent = button.closest('.express-delivery-field, .gift-message-field');
      checkbox = parent ? parent.querySelector('.' + checkboxClass) : null;
    }

    if (!checkbox) return;

    // Update button state based on checkbox state
    function updateButtonState() {
      if (checkbox.checked) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    }

    // Initialize button state
    updateButtonState();

    // Handle button click
    button.addEventListener('click', function (e) {
      e.preventDefault();
      // Toggle checkbox
      checkbox.checked = !checkbox.checked;

      // Update button state
      updateButtonState();

      // Trigger change event on checkbox to maintain existing functionality
      const changeEvent = new Event('change', { bubbles: true });
      checkbox.dispatchEvent(changeEvent);
    });

    // Listen for checkbox changes (in case it's changed programmatically)
    checkbox.addEventListener('change', updateButtonState);
  });
});

// Pages Buttons - Radio Button Behavior
document.addEventListener('DOMContentLoaded', function () {
  // Group buttons by their input field
  const pagesGroups = {};

  document.querySelectorAll('.pages-button').forEach(button => {
    const selectId = button.getAttribute('data-select-id');
    const selectClass = button.getAttribute('data-select-class');
    const key = selectId || selectClass;

    if (!pagesGroups[key]) {
      pagesGroups[key] = [];
    }
    pagesGroups[key].push(button);
  });

  // Process each group
  Object.keys(pagesGroups).forEach(key => {
    const buttons = pagesGroups[key];
    const firstButton = buttons[0];
    const selectId = firstButton.getAttribute('data-select-id');
    const selectClass = firstButton.getAttribute('data-select-class');

    let hiddenInput;
    if (selectId) {
      hiddenInput = document.getElementById(selectId);
    } else if (selectClass) {
      const parent = firstButton.closest('.pages-field');
      hiddenInput = parent ? parent.querySelector('.' + selectClass) : null;
    }

    if (!hiddenInput) return;

    // Update all buttons in this group
    function updateAllButtons() {
      buttons.forEach(btn => {
        const btnValue = btn.getAttribute('data-pages-value');
        if (hiddenInput.value === btnValue) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
    }

    // Initialize button state
    updateAllButtons();

    // Add click handlers
    buttons.forEach(button => {
      const pagesValue = button.getAttribute('data-pages-value');

      button.addEventListener('click', function (e) {
        e.preventDefault();
        hiddenInput.value = pagesValue;
        updateAllButtons();

        // Trigger change event
        const changeEvent = new Event('change', { bubbles: true });
        hiddenInput.dispatchEvent(changeEvent);
      });
    });

    // Listen for changes on the hidden input (e.g. from URL initialization)
    if (hiddenInput) {
      hiddenInput.addEventListener('change', updateAllButtons);
    }
  });
});

// Language Buttons - Radio Button Behavior
document.addEventListener('DOMContentLoaded', function () {
  // Group buttons by their input field
  const languageGroups = {};

  document.querySelectorAll('.language-button').forEach(button => {
    const selectId = button.getAttribute('data-select-id');
    const selectClass = button.getAttribute('data-select-class');
    const key = selectId || selectClass;

    if (!languageGroups[key]) {
      languageGroups[key] = [];
    }
    languageGroups[key].push(button);
  });

  // Process each group
  Object.keys(languageGroups).forEach(key => {
    const buttons = languageGroups[key];
    const firstButton = buttons[0];
    const selectId = firstButton.getAttribute('data-select-id');
    const selectClass = firstButton.getAttribute('data-select-class');

    let hiddenInput;
    if (selectId) {
      hiddenInput = document.getElementById(selectId);
    } else if (selectClass) {
      const parent = firstButton.closest('.info-field');
      hiddenInput = parent ? parent.querySelector('.' + selectClass) : null;
    }

    if (!hiddenInput) return;

    // Update all buttons in this group
    function updateAllButtons() {
      buttons.forEach(btn => {
        const btnValue = btn.getAttribute('data-language-value');
        if (hiddenInput.value === btnValue) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
    }

    // Initialize button state
    updateAllButtons();

    // Add click handlers
    buttons.forEach(button => {
      const languageValue = button.getAttribute('data-language-value');

      button.addEventListener('click', function (e) {
        e.preventDefault();
        hiddenInput.value = languageValue;
        updateAllButtons();

        // Trigger change event
        const changeEvent = new Event('change', { bubbles: true });
        hiddenInput.dispatchEvent(changeEvent);
      });
    });

    // Listen for changes on the hidden input (e.g. from URL initialization)
    if (hiddenInput) {
      hiddenInput.addEventListener('change', updateAllButtons);
    }
  });
});

// Age Buttons - Radio Button Behavior (from metafield Kid_Age)
document.addEventListener('DOMContentLoaded', function () {
  const ageButtons = document.querySelectorAll('.age-button');
  const kidAgeInput = document.getElementById('kid-age');
  const storyAgeInput = document.getElementById('story-age');

  if (!kidAgeInput || ageButtons.length === 0) return;

  // Update all buttons based on selected value
  function updateAllAgeButtons() {
    const selectedValue = kidAgeInput.value;
    ageButtons.forEach(btn => {
      const btnKidAge = btn.getAttribute('data-kid-age');
      if (btnKidAge === selectedValue) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  // Initialize button state
  updateAllAgeButtons();

  // Add click handlers
  ageButtons.forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const kidAge = this.getAttribute('data-kid-age');
      const storyAge = this.getAttribute('data-story-age');

      kidAgeInput.value = kidAge || '';
      if (storyAgeInput) {
        storyAgeInput.value = storyAge || '';
      }

      updateAllAgeButtons();

      // Trigger change event
      const changeEvent = new Event('change', { bubbles: true });
      kidAgeInput.dispatchEvent(changeEvent);
    });
  });

  // Listen for changes on the hidden input
  kidAgeInput.addEventListener('change', updateAllAgeButtons);
});

// Gift Box Button - Toggle Behavior
document.addEventListener('DOMContentLoaded', function () {
  const giftBoxButtons = document.querySelectorAll('.gift-box-button');

  giftBoxButtons.forEach(button => {
    const checkboxId = button.getAttribute('data-checkbox-id');
    const checkboxClass = button.getAttribute('data-checkbox-class');

    let hiddenInput;
    if (checkboxId) {
      hiddenInput = document.getElementById(checkboxId);
    } else if (checkboxClass) {
      const parent = button.closest('.gift-wrapping-field');
      hiddenInput = parent ? parent.querySelector('.' + checkboxClass) : null;
    }

    if (!hiddenInput) return;

    // Update button state based on input value
    function updateButtonState() {
      if (hiddenInput.value === 'Yes') {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    }

    // Initialize button state
    updateButtonState();

    // Handle button click
    button.addEventListener('click', function (e) {
      e.preventDefault();
      // Toggle value
      hiddenInput.value = hiddenInput.value === 'Yes' ? 'No' : 'Yes';
      updateButtonState();

      // Trigger change event
      const changeEvent = new Event('change', { bubbles: true });
      hiddenInput.dispatchEvent(changeEvent);
    });
  });
});

// Gift Message Textarea Toggle with Animation
document.addEventListener('DOMContentLoaded', function () {
  // Handle all gift message checkboxes
  const giftMessageCheckboxes = document.querySelectorAll('#gift-message-checkbox, .gift-message-checkbox');

  giftMessageCheckboxes.forEach(checkbox => {
    const parent = checkbox.closest('.gift-message-field');
    let textareaWrapper = null;
    if (parent) {
      const nextSibling = parent.nextElementSibling;
      if (nextSibling && (nextSibling.classList.contains('gift-message-textarea-wrapper') || nextSibling.id === 'gift-message-textarea-wrapper')) {
        textareaWrapper = nextSibling;
      } else {
        const container = parent.closest('.additional-options-fields');
        if (container) {
          textareaWrapper = container.querySelector('#gift-message-textarea-wrapper, .gift-message-textarea-wrapper');
        }
      }
    }
    if (!textareaWrapper) {
      textareaWrapper = document.querySelector('#gift-message-textarea-wrapper, .gift-message-textarea-wrapper');
    }
    const textarea = textareaWrapper ? textareaWrapper.querySelector('#gift-message-text, .gift-message-text') : null;

    // Toggle textarea visibility with animation
    if (!textareaWrapper) return; // Exit if textarea wrapper not found

    checkbox.addEventListener('change', function () {
      if (this.checked) {
        // Open with animation
        textareaWrapper.style.display = 'block';
        // Force reflow to ensure the transition works
        void textareaWrapper.offsetHeight;
        textareaWrapper.classList.add('active');
      } else {
        // Close with animation
        textareaWrapper.classList.remove('active');
        // Wait for animation to complete before hiding
        setTimeout(() => {
          if (!checkbox.checked) {
            textareaWrapper.style.display = 'none';
            if (textarea) {
              textarea.value = '';
            }
          }
        }, 400); // Match the CSS transition duration
      }
    });
  });
});

// Update Total Price with Express Delivery and Gift Message costs
document.addEventListener('DOMContentLoaded', function () {
  const EXPRESS_DELIVERY_COST = 40000; // 400 EGP in cents
  const GIFT_MESSAGE_COST = 20000; // 200 EGP in cents
  let GIFT_BOX_COST = 50000; // Default fallback (500 EGP) - Updated dynamically

  // Fetch dynamic price for Gift Box
  async function fetchGiftBoxPrice() {
    try {
      const response = await fetch('/products/gift.js');
      if (response.ok) {
        const product = await response.json();
        const targetId = 14861245612402; // User provided ID

        // Check if this product matches the ID or if we should use its price regardless
        if (product.id === targetId || product.handle === 'gift') {
          // Use the first variant's price
          GIFT_BOX_COST = product.price;
          if (window.updateAllPrices) window.updateAllPrices();
        }
      }
    } catch (e) {
      console.warn('Failed to fetch dynamic gift box price:', e);
    }
  }

  // Initialize price fetch
  fetchGiftBoxPrice();

  // Get Shopify settings - these will be injected by the liquid file
  const currencyCodeEnabled = window.SHOPIFY_CURRENCY_CODE_ENABLED || false;
  const currencySymbol = window.SHOPIFY_CURRENCY_SYMBOL || '';
  const currencyCode = window.SHOPIFY_CURRENCY_ISO_CODE || 'USD';

  function formatPrice(priceInCents) {
    if (currencyCodeEnabled) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(priceInCents / 100);
    } else {
      return (priceInCents / 100).toFixed(0) + ' ' + currencySymbol;
    }
  }

  function calculateTotalPrice() {
    // Get base variant price
    const currentPriceDisplay = document.getElementById('current-price-display');
    if (!currentPriceDisplay) return;

    const basePrice = parseInt(currentPriceDisplay.getAttribute('data-base-price')) || 0;
    let totalPrice = basePrice;

    // Add express delivery cost if checked
    const expressCheckbox = document.querySelector('#express-delivery, .express-delivery');
    if (expressCheckbox && expressCheckbox.checked) {
      totalPrice += EXPRESS_DELIVERY_COST;
    }

    // Add gift message cost if checked
    const giftMessageCheckbox = document.querySelector('#gift-message-checkbox, .gift-message-checkbox');
    if (giftMessageCheckbox && giftMessageCheckbox.checked) {
      totalPrice += GIFT_MESSAGE_COST;
    }

    // Add gift box cost if selected
    const giftBoxButtonActive = document.querySelector('.gift-box-button.active');
    const giftBoxInput = document.querySelector('#gift-wrapping, [name="gift-wrapping"]');

    // Strict check: if input is Yes OR a button is explicitly active.
    // We trust that the listener keeps them in sync, but we prefer the input.
    const isGiftBoxSelected = (giftBoxInput && giftBoxInput.value === 'Yes') || (giftBoxButtonActive !== null);

    if (isGiftBoxSelected) {
      totalPrice += GIFT_BOX_COST;
    }

    return totalPrice;
  }

  function updateAllPrices() {
    const totalPrice = calculateTotalPrice();
    const formattedPrice = formatPrice(totalPrice);

    // Update current price display
    const currentPriceDisplay = document.getElementById('current-price-display');
    if (currentPriceDisplay) {
      currentPriceDisplay.textContent = formattedPrice;
    }

    // Update compare at price if it exists
    const comparePriceDisplay = document.getElementById('compare-price-display');
    if (comparePriceDisplay) {
      const baseComparePrice = parseInt(comparePriceDisplay.getAttribute('data-base-price')) || 0;
      let totalComparePrice = baseComparePrice;

      // Add same extras to compare price
      const expressCheckbox = document.querySelector('#express-delivery, .express-delivery');
      if (expressCheckbox && expressCheckbox.checked) {
        totalComparePrice += EXPRESS_DELIVERY_COST;
      }

      const giftMessageCheckbox = document.querySelector('#gift-message-checkbox, .gift-message-checkbox');
      if (giftMessageCheckbox && giftMessageCheckbox.checked) {
        totalComparePrice += GIFT_MESSAGE_COST;
      }

      // Add gift box to compare price as well
      const giftBoxButtonActive = document.querySelector('.gift-box-button.active');
      const giftBoxInput = document.querySelector('#gift-wrapping, [name="gift-wrapping"]');
      if ((giftBoxInput && giftBoxInput.value === 'Yes') || !!giftBoxButtonActive) {
        totalComparePrice += GIFT_BOX_COST;
      }

      comparePriceDisplay.textContent = formatPrice(totalComparePrice);


      // Update savings amount and discount badge
      const savings = totalComparePrice - totalPrice;
      if (savings > 0) {
        const savingsAmount = document.querySelector('.savings-amount');
        if (savingsAmount) {
          savingsAmount.textContent = 'You save ' + formatPrice(savings);
        }

        const discountBadge = document.querySelector('.discount-badge');
        if (discountBadge) {
          discountBadge.textContent = 'You save ' + formatPrice(savings);
        }
      }
    }

    // Update Add to Cart button price
    const buttonPriceSpans = document.querySelectorAll('.button-price');
    buttonPriceSpans.forEach(span => {
      span.textContent = formattedPrice;
    });
  }

  // Expose globally so other functions can call it
  window.updateAllPrices = updateAllPrices;

  // Function to sync URL with addon state
  function syncUrlWithAddonState() {
    const expressCheckbox = document.querySelector('#express-delivery, .express-delivery');
    const giftMessageCheckbox = document.querySelector('#gift-message-checkbox, .gift-message-checkbox');
    const giftMessageText = document.querySelector('#gift-message-text, .gift-message-text');

    const urlObj = new URL(window.location.href);

    // Update Express parameter
    if (expressCheckbox && expressCheckbox.checked) {
      urlObj.searchParams.set('express', '1');
    } else {
      urlObj.searchParams.delete('express');
    }

    // Update Gift Message parameters
    if (giftMessageCheckbox && giftMessageCheckbox.checked) {
      urlObj.searchParams.set('gift_message', '1');
      if (giftMessageText && giftMessageText.value.trim()) {
        // URLSearchParams.set() handles encoding automatically
        urlObj.searchParams.set('message', giftMessageText.value);
      } else {
        urlObj.searchParams.delete('message');
      }
    } else {
      urlObj.searchParams.delete('gift_message');
      urlObj.searchParams.delete('message');
    }

    // Update URL without reload
    const newUrl = urlObj.pathname + urlObj.search;
    if (newUrl !== window.location.pathname + window.location.search) {
      history.replaceState(history.state, '', newUrl);
    }
  }

  // Listen for checkbox changes
  const expressCheckboxes = document.querySelectorAll('#express-delivery, .express-delivery');
  const giftMessageCheckboxes = document.querySelectorAll('#gift-message-checkbox, .gift-message-checkbox');

  expressCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function () {
      updateAllPrices();
      syncUrlWithAddonState();
    });
  });

  giftMessageCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function () {
      updateAllPrices();
      syncUrlWithAddonState();
    });
  });

  // Listen for gift message text changes
  const giftMessageTextareas = document.querySelectorAll('#gift-message-text, .gift-message-text');
  giftMessageTextareas.forEach(textarea => {
    // Update URL when user types (debounced)
    let typingTimer;
    textarea.addEventListener('input', function () {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(syncUrlWithAddonState, 500);
    });
  });

  // Listen for variant changes
  const variantInputs = document.querySelectorAll('.product-variant-id');
  variantInputs.forEach(input => {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          // Update base prices when variant changes
          setTimeout(updateAllPrices, 100); // Small delay to let prices update
        }
      });
    });

    observer.observe(input, { attributes: true });
  });
});

// Kid Name Language Validation
document.addEventListener('DOMContentLoaded', function () {
  // Helper function to get current story language from URL/handle
  function getCurrentStoryLanguage() {
    // Check selected language from input first
    const storyLanguageInput = document.querySelector('#story-language, .story-language');
    if (storyLanguageInput && storyLanguageInput.value) {
      return storyLanguageInput.value;
    }

    // Fallback to URL
    const currentUrl = window.location.pathname;
    // Check if URL contains -ar (indicating Arabic version)
    return currentUrl.includes('-ar') ? 'Arabic' : 'English';
  }

  // Helper function to detect if text contains Arabic characters
  function containsArabic(text) {
    const arabicPattern = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
    return arabicPattern.test(text);
  }

  // Helper function to detect if text contains Latin characters (English and other Latin-based languages)
  function containsLatin(text) {
    // Includes basic Latin, Latin Extended (for European languages), and common diacritics
    const latinPattern = /[a-zA-ZÀ-ÿ\u0100-\u017F\u0180-\u024F\u1E00-\u1EFF]/;
    return latinPattern.test(text);
  }

  // Function to show error message
  function showFormError(form, message) {
    const errorWrapper = form.closest('product-form').querySelector('.product-form__error-message-wrapper');
    const errorMessage = form.closest('product-form').querySelector('.product-form__error-message');

    // Reset sticky button state immediately on any error
    const stickyButton = document.getElementById('sticky-add-to-cart');
    if (stickyButton) {
      stickyButton.disabled = false;
      stickyButton.classList.remove('loading');
      const stickySpinner = stickyButton.querySelector('.loading__spinner');
      if (stickySpinner) stickySpinner.classList.add('hidden');
    }

    if (errorWrapper && errorMessage) {
      errorMessage.textContent = message;
      errorWrapper.removeAttribute('hidden');

      // Scroll to error message
      errorWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Hide error after 5 seconds
      setTimeout(() => {
        errorWrapper.setAttribute('hidden', '');
      }, 5000);
    } else {
      // Fallback to alert if error elements not found
      alert(message);
    }
  }

  // Function to hide error message
  function hideFormError(form) {
    const errorWrapper = form.closest('product-form').querySelector('.product-form__error-message-wrapper');
    if (errorWrapper) {
      errorWrapper.setAttribute('hidden', '');
    }
  }

  // Toaster notification function (copied from product-uploader.js)
  function showToaster(message, type = 'info') {
    const existing = document.querySelector('.toaster');
    if (existing) existing.remove();
    const el = document.createElement('div');
    el.className = `toaster toaster-${type}`;
    let icon = '<i class="fas fa-info-circle"></i>';
    if (type === 'success') icon = '<i class="fas fa-check-circle"></i>';
    if (type === 'error') icon = '<i class="fas fa-exclamation-circle"></i>';
    if (type === 'warning') icon = '<i class="fas fa-exclamation-triangle"></i>';
    el.innerHTML = `
      <div class="toaster-content">
        ${icon}
        <span class="toaster-message">${message}</span>
        <button class="toaster-close" aria-label="Close" onclick="this.parentElement.parentElement.remove()">
          <i class="fas fa-times"></i>
        </button>
      </div>
    `;
    document.body.appendChild(el);
    setTimeout(() => el.classList.add('toaster-show'), 50);
    setTimeout(() => { if (el && el.parentElement) el.remove(); }, type === 'error' ? 5000 : 3000);

    // Reset sticky button state immediately on any toaster (especially error)
    const stickyButton = document.getElementById('sticky-add-to-cart');
    if (stickyButton) {
      stickyButton.disabled = false;
      stickyButton.classList.remove('loading');
      const stickySpinner = stickyButton.querySelector('.loading__spinner');
      if (stickySpinner) stickySpinner.classList.add('hidden');
    }
  }

  // Helper function to convert language to 2-letter code
  function getLanguageCode(language) {
    if (!language) return 'en';
    const lang = String(language).toLowerCase().trim();

    // Exact matches for Shopify admin language values
    if (lang === 'english' || lang === 'en') return 'en';
    if (lang === 'arabic' || lang === 'ar') return 'ar';
    if (lang === 'german' || lang === 'de') return 'de';
    if (lang === 'french' || lang === 'fr') return 'fr';
    if (lang === 'spanish' || lang === 'es') return 'es';
    if (lang === 'italian' || lang === 'it') return 'it';

    // Fallback: check if contains language name
    if (lang.includes('arabic') || lang.includes('عربي')) return 'ar';
    if (lang.includes('german') || lang.includes('deutsch')) return 'de';
    if (lang.includes('french') || lang.includes('français')) return 'fr';
    if (lang.includes('spanish') || lang.includes('español')) return 'es';
    if (lang.includes('italian') || lang.includes('italiano')) return 'it';

    return 'en'; // Default to English
  }

  // Helper function to determine if variant is 12 or 20 pages
  function getPagesType(variant) {
    if (!variant) return 'long';
    const options = variant.options || [];
    const optionsText = options.join(' ').toLowerCase();

    // Check if it's 20 pages (long)
    if (optionsText.includes('20') || optionsText.includes('20 pages')) {
      return 'long';
    }
    // Check if it's 12 pages (short)
    if (optionsText.includes('12') || optionsText.includes('12 pages')) {
      return 'short';
    }
    // Check handle for -short suffix
    const handle = window.location.pathname.split('/').pop() || '';
    if (handle.includes('-short')) {
      return 'short';
    }
    // Default to long if handle doesn't have -short
    return 'long';
  }

  // Helper function to get product handle
  function getProductHandle() {
    // Try to get from URL
    const pathParts = window.location.pathname.split('/');
    const handle = pathParts[pathParts.length - 1];
    if (handle) {
      // Remove language suffix and page suffix
      return handle.replace(/-ar$|-de$|-fr$|-es$|-it$|-en$/i, '')
        .replace(/-short$|-long$/i, '');
    }
    return '';
  }

  // Helper function to generate custom SKU
  function generateCustomSKU(variant, properties) {
    // 1. Story name (product handle, remove language suffix and -short if present)
    let storyName = getProductHandle();

    // 2. Pages type (long/short)
    const rawPagesType = getPagesType(variant);
    // User request: 20 pages (long) is default, so represent as empty string
    const pagesType = rawPagesType === 'long' ? '' : rawPagesType;

    // 3. Story_Age (from properties)
    const storyAge = properties['Story Age'] || '';

    // 4. Language (2-letter code)
    const language = properties['Story Language'] || 'English';
    const langCode = getLanguageCode(language);

    // 5. Build SKU parts
    // Order: Name -> Age -> Type -> Language
    const skuParts = [storyName];

    // Story Age comes AFTER story name
    if (storyAge) {
      skuParts.push(storyAge);
    }

    // Then Pages Type (only if not empty/default)
    if (pagesType) {
      skuParts.push(pagesType);
    }

    // Then Language code (if not English)
    if (langCode !== 'en') {
      skuParts.push(langCode);
    }

    // 6. Add express, giftnote, gift if selected
    if (properties['Express'] === 'Yes') {
      skuParts.push('express');
    }
    if (properties['Gift Note'] === 'Yes') {
      skuParts.push('giftnote');
    }

    // Check if gift box is selected (separate product, but we check the button state)
    const giftBoxButtonActive = document.querySelector('.gift-box-button.active');
    const giftBoxInput = document.querySelector('#gift-wrapping, [name="gift-wrapping"]');
    const hasGiftBox = (giftBoxInput && giftBoxInput.value === 'Yes') || !!giftBoxButtonActive;
    if (hasGiftBox) {
      skuParts.push('gift');
    }

    return skuParts.join('-');
  }

  // Handle Add to Cart with Express and Gift Note extras
  async function handleAddToCartWithExtras(form) {
    const formData = new FormData(form);
    const items = [];

    // Get main product data
    const variantId = formData.get('id');
    const quantity = formData.get('quantity') || 1;

    // Get current variant for SKU generation
    const currentVariant = window.productVariants?.find(v => v.id == variantId);

    // Build properties for main product
    const properties = {};

    // Add all form fields as properties
    const kidNameInput = document.querySelector('#kid-name-input');
    if (kidNameInput && kidNameInput.value.trim()) {
      properties['Kid Name'] = kidNameInput.value.trim();
    }

    const kidAgeInput = document.querySelector('#kid-age, .kid-age');
    if (kidAgeInput && kidAgeInput.value) {
      properties['Kid Age'] = kidAgeInput.value;
    }

    // Story Age is included in SKU, so we add it as a separate property if present
    const storyAgeInput = document.querySelector('#story-age');
    if (storyAgeInput && storyAgeInput.value) {
      properties['Story Age'] = storyAgeInput.value;
    }

    const storyLanguageSelect = document.querySelector('#story-language, .story-language');
    if (storyLanguageSelect && storyLanguageSelect.value) {
      properties['Story Language'] = storyLanguageSelect.value;
    }

    // Number of Pages and Pages are included in SKU, so we don't add them as separate properties
    // const numberOfPagesSelect = document.querySelector('#number-of-pages, .number-of-pages');
    // Pages information is used in SKU generation but not displayed as a property

    // Check if Gift Box is selected (for separate product addition)
    // Prefer the input inside this form; fall back to any on the page
    const giftBoxInput = form.querySelector('#gift-wrapping, [name="gift-wrapping"]') || document.querySelector('#gift-wrapping');
    const giftBoxButtonActive = document.querySelector('.gift-box-button.active');
    const isGiftBoxSelected = (giftBoxInput && giftBoxInput.value === 'Yes') || !!giftBoxButtonActive;

    // Check if Express Delivery is selected
    const expressCheckbox = document.querySelector('#express-delivery, .express-delivery');
    const isExpressSelected = expressCheckbox && expressCheckbox.checked;

    // Check if Gift Message is selected
    const giftMessageCheckbox = document.querySelector('#gift-message-checkbox, .gift-message-checkbox');
    const isGiftMessageSelected = giftMessageCheckbox && giftMessageCheckbox.checked;
    const giftMessageText = document.querySelector('#gift-message-text, .gift-message-text');

    // Validate Gift Message length if selected
    if (isGiftMessageSelected) {
      if (!giftMessageText || !giftMessageText.value || giftMessageText.value.trim().length < 10) {
        showToaster('Gift message must be at least 10 characters long.', 'error');
        // Also scroll to the textarea
        if (giftMessageText) {
          giftMessageText.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => giftMessageText.focus(), 500);
        }

        // Reset sticky button state
        // Handled by showToaster now

        return;
      }
    }

    // Add Express property
    if (isExpressSelected) {
      properties['Express'] = 'Yes';
    }

    // Add Gift Note property
    if (isGiftMessageSelected) {
      properties['Gift Note'] = 'Yes';
      if (giftMessageText && giftMessageText.value.trim()) {
        properties['Gift Message'] = giftMessageText.value.trim();
      }
    }

    // Add Gift Box property
    if (isGiftBoxSelected) {
      properties['Gift Box'] = 'Yes';
    }


    // Add Photo properties (dynamically added by product-uploader.js)
    const photoInputs = form.querySelectorAll('input[name^="properties[Photo"]');
    photoInputs.forEach(input => {
      // Extract the property name from the input name, e.g., "properties[Photo 1]" -> "Photo 1"
      const match = input.name.match(/properties\[(.*?)\]/);
      if (match && match[1]) {
        properties[match[1]] = input.value;
      }
    });

    // Generate and add SKU
    const customSku = generateCustomSKU(currentVariant, properties);
    if (customSku) {
      properties['SKU'] = customSku;
      console.log('🏷️ Generated SKU:', customSku);
    }

    // Add main product to items array
    const mainItem = {
      id: variantId,
      quantity: quantity,
      properties: properties
    };
    items.push(mainItem);


    // Fetch all products to find gift box, express and gift-note SKUs
    try {
      // Add Gift Box product if selected
      if (isGiftBoxSelected) {
        const giftBoxVariant = await findVariantBySKU('gift');
        if (giftBoxVariant) {
          const giftVariantIdNum = parseInt(giftBoxVariant.id, 10);
          if (!isNaN(giftVariantIdNum)) {
            items.push({
              id: giftVariantIdNum,
              quantity: 1
            });
          } else {
            console.warn('Gift Box variant ID is invalid:', giftBoxVariant.id);
          }
        } else {
          console.warn('Gift Box product (SKU: gift) not found');
        }
      }

      // Add Express product if checkbox is selected
      if (isExpressSelected) {
        const expressVariant = await findVariantBySKU('express');
        if (expressVariant) {
          items.push({
            id: expressVariant.id,
            quantity: 1
          });
        } else {
          console.warn('Express delivery product (SKU: express) not found');
        }
      }

      // Add Gift Note product if checkbox is selected
      if (isGiftMessageSelected) {
        const giftNoteVariant = await findVariantBySKU('gift-note');
        if (giftNoteVariant) {
          items.push({
            id: giftNoteVariant.id,
            quantity: 1
          });
        } else {
          console.warn('Gift Note product (SKU: gift-note) not found');
        }
      }


      // Show loading state on button
      const submitButton = form.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('loading');

        // Show the spinner
        const spinner = submitButton.querySelector('.loading__spinner');
        if (spinner) {
          spinner.classList.remove('hidden');
        }

        // Optional: Change button text (the text will be transparent due to CSS)
        const buttonTextSpan = submitButton.querySelector('span:first-child');
        if (buttonTextSpan) {
          buttonTextSpan.dataset.originalText = buttonTextSpan.textContent;
          buttonTextSpan.textContent = 'Adding to Cart...';
        }
      }

      // Add all items to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items })
      });

      const resetButton = () => {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('loading');

          // Hide the spinner
          const spinner = submitButton.querySelector('.loading__spinner');
          if (spinner) {
            spinner.classList.add('hidden');
          }

          // Restore original button text
          const buttonTextSpan = submitButton.querySelector('span:first-child');
          if (buttonTextSpan && buttonTextSpan.dataset.originalText) {
            buttonTextSpan.textContent = buttonTextSpan.dataset.originalText;
            delete buttonTextSpan.dataset.originalText;
          }
        }

        // Reset sticky button state
        const stickyButton = document.getElementById('sticky-add-to-cart');
        if (stickyButton) {
          stickyButton.disabled = false;
          stickyButton.classList.remove('loading');
          const stickySpinner = stickyButton.querySelector('.loading__spinner');
          if (stickySpinner) stickySpinner.classList.add('hidden');
        }
      };

      if (response.ok) {
        const data = await response.json();

        // Check if cart drawer exists
        const cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');

        if (cartDrawer) {
          // Method 1: Try to use Shopify's section rendering
          try {
            // Fetch updated sections
            const sections = ['cart-drawer', 'cart-icon-bubble'];
            const sectionsUrl = `/?sections=${sections.join(',')}`;

            const sectionsResponse = await fetch(sectionsUrl);
            const sectionsData = await sectionsResponse.json();


            // Update cart drawer section
            if (sectionsData['cart-drawer']) {
              const parser = new DOMParser();
              const htmlDoc = parser.parseFromString(sectionsData['cart-drawer'], 'text/html');

              // Get the cart drawer element
              const currentCartDrawer = document.querySelector('cart-drawer');
              const newCartDrawer = htmlDoc.querySelector('cart-drawer');

              if (newCartDrawer && currentCartDrawer) {
                // CRITICAL: Update cart-drawer class FIRST (remove is-empty)
                currentCartDrawer.className = newCartDrawer.className;

                // Replace the entire drawer__inner content to properly switch between empty and filled states
                const newDrawerInner = htmlDoc.querySelector('.drawer__inner');
                const currentDrawerInner = currentCartDrawer.querySelector('.drawer__inner');

                if (newDrawerInner && currentDrawerInner) {
                  // Replace entire inner content
                  currentDrawerInner.innerHTML = newDrawerInner.innerHTML;

                  // Force a reflow to ensure DOM updates are processed
                  void currentCartDrawer.offsetHeight;
                } else {
                  console.error('Could not find drawer__inner element');
                }
              } else {
                console.error('Could not find cart-drawer element');
              }
            }

            // Update cart icon bubble
            if (sectionsData['cart-icon-bubble']) {
              const parser = new DOMParser();
              const htmlDoc = parser.parseFromString(sectionsData['cart-icon-bubble'], 'text/html');
              const newBubble = htmlDoc.querySelector('.cart-count-bubble');
              const currentBubble = document.querySelector('.cart-count-bubble');
              if (newBubble && currentBubble) {
                currentBubble.textContent = newBubble.textContent;
              }
            }

            // Use requestAnimationFrame to ensure DOM updates are fully processed
            await new Promise(resolve => {
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  // Double RAF ensures paint is complete
                  resolve();
                });
              });
            });

            // Now open the drawer
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }

            resetButton();

          } catch (error) {
            console.error('Error refreshing cart drawer:', error);
            // Fallback: just redirect to cart page
            window.location.href = '/cart';
          }
        } else if (cartNotification && typeof cartNotification.open === 'function') {
          // Show cart notification
          cartNotification.open();
          resetButton();
        } else {
          // Fallback: redirect to cart page (don't reset button)
          window.location.href = '/cart';
        }

        // Trigger cart update events for other parts of the page
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (window.Shopify && window.Shopify.theme && window.Shopify.theme.publish) {
          window.Shopify.theme.publish('cart:refresh');
        }
      } else {
        const error = await response.json();
        console.error('Error adding to cart:', error);

        // Show error message
        const errorMessage = error.description || 'Error adding to cart. Please try again.';
        showFormError(form, errorMessage);

        resetButton();
      }
    } catch (error) {
      console.error('Error in handleAddToCartWithExtras:', error);
      showFormError(form, 'Error adding to cart. Please try again.');

      // Reset button state
      const submitButton = form.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.classList.remove('loading');
        const buttonTextSpan = submitButton.querySelector('span:first-child');
        if (buttonTextSpan && buttonTextSpan.dataset.originalText) {
          buttonTextSpan.textContent = buttonTextSpan.dataset.originalText;
          delete buttonTextSpan.dataset.originalText;
        }
      }

      // Reset sticky button state
      const stickyButton = document.getElementById('sticky-add-to-cart');
      if (stickyButton) {
        stickyButton.disabled = false;
        stickyButton.classList.remove('loading');
        const stickySpinner = stickyButton.querySelector('.loading__spinner');
        if (stickySpinner) stickySpinner.classList.add('hidden');
      }
    }
  }

  // Function to find variant by SKU
  async function findVariantBySKU(sku) {
    try {
      // Search through all products to find the variant with matching SKU
      const response = await fetch('/products.json?limit=250');
      const data = await response.json();

      for (const product of data.products) {
        for (const variant of product.variants) {
          if (variant.sku && variant.sku.toLowerCase() === sku.toLowerCase()) {
            return variant;
          }
        }
      }

      console.warn(`Variant with SKU "${sku}" not found`);
      return null;
    } catch (error) {
      console.error('Error finding variant by SKU:', error);
      return null;
    }
  }

  // Intercept form submission for single product
  const productForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');

  productForms.forEach(form => {
    form.addEventListener('submit', function (e) {
      // Always prevent default submission
      e.preventDefault();
      e.stopImmediatePropagation();

      // Get kid name input
      const kidNameInput = document.getElementById('kid-name-input');

      // Only validate if kid name input exists
      if (kidNameInput) {
        // Kid Name Language Validation removed - handled by product-uploader.js


        hideFormError(form);
      }

      // Validate Age
      const kidAgeInput = document.getElementById('kid-age');
      const kidAgeFallback = document.getElementById('kid-age-fallback');
      let ageValue = '';

      if (kidAgeFallback) {
        ageValue = kidAgeFallback.value;
      } else if (kidAgeInput) {
        ageValue = kidAgeInput.value;
      }

      if (!ageValue) {
        showFormError(form, 'Please select the kid\'s age.');
        // Scroll to age section
        const ageSection = document.querySelector('.kid-age-field');
        if (ageSection) {
          ageSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return false;
      }

      // Add custom properties for Express and Gift Message
      handleAddToCartWithExtras(form);
      return false;
    }, true); // Use capture phase to ensure we catch it first
  });

  // Also validate when kid name changes or URL changes (show immediate feedback)
  const kidNameInput = document.getElementById('kid-name-input');

  if (kidNameInput) {
    function validateOnChange() {
      const validation = validateKidNameLanguage(kidNameInput.value);

      if (!validation.valid && kidNameInput.value.trim() !== '') {
        kidNameInput.style.borderColor = '#dc2626';
        kidNameInput.style.boxShadow = '0 0 0 1px #dc2626';
      } else {
        kidNameInput.style.borderColor = '#e5e7eb';
        kidNameInput.style.boxShadow = 'none';
      }
    }

    // Validation listeners removed - handled by product-uploader.js
  }
});

// Sticky Add to Cart Button Handler
document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.getElementById('sticky-atc-bar');
  const stickyButton = document.getElementById('sticky-add-to-cart');

  if (!stickyBar || !stickyButton) return;

  // Find the main Add to Cart button (optional)
  const mainAddToCartButton = document.querySelector('button[type="submit"][name="add"]');

  // Make sticky bar always visible
  stickyBar.classList.remove('hidden');
  stickyBar.classList.add('visible');

  // Sync the price display with the main price
  function updateStickyPrice() {
    const currentPriceDisplay = document.getElementById('current-price-display');
    const comparePriceDisplay = document.getElementById('compare-price-display');
    const stickyPriceSpan = document.querySelector('.sticky-button-price');
    const stickyCurrentPrice = document.querySelector('.sticky-current-price');
    const stickyComparePrice = document.querySelector('.sticky-compare-price');
    const stickySavingsBadge = document.getElementById('sticky-savings-badge');

    if (currentPriceDisplay && stickyPriceSpan) {
      stickyPriceSpan.textContent = currentPriceDisplay.textContent;
    }

    if (currentPriceDisplay && stickyCurrentPrice) {
      stickyCurrentPrice.textContent = currentPriceDisplay.textContent;
    }

    // Update compare price and savings badge
    if (comparePriceDisplay && stickyComparePrice) {
      stickyComparePrice.textContent = comparePriceDisplay.textContent;

      // Show/hide compare price based on whether it has content
      if (comparePriceDisplay.textContent.trim()) {
        stickyComparePrice.style.display = '';
      } else {
        stickyComparePrice.style.display = 'none';
      }
    }

    // Update savings badge with the main savings amount badge
    if (stickySavingsBadge) {
      const mainSavingsAmount = document.querySelector('.savings-amount:not(#sticky-savings-badge)');

      if (mainSavingsAmount && mainSavingsAmount.textContent.trim()) {
        stickySavingsBadge.textContent = mainSavingsAmount.textContent;
        stickySavingsBadge.style.display = 'inline-block';
      } else {
        stickySavingsBadge.style.display = 'none';
      }
    }
  }

  // Update on page load
  updateStickyPrice();

  // Update when price changes
  const currentPriceDisplay = document.getElementById('current-price-display');
  if (currentPriceDisplay) {
    const priceObserver = new MutationObserver(updateStickyPrice);
    priceObserver.observe(currentPriceDisplay, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  // When sticky button is clicked, trigger the main Add to Cart button or Quick Order
  stickyButton.addEventListener('click', function (e) {
    e.preventDefault();

    // Check validation if available (from quick-order-form.liquid)
    // We can rely on submitQuickOrder for this, but if we want to run just product validation first:
    // Actually submitQuickOrder calls validateQuickOrderProductProperties internally.

    if (window.submitQuickOrder) {
      window.submitQuickOrder(stickyButton);
      return;
    }

    // Fallback: If Quick Order system is not present, use standard Add to Cart
    if (window.validateQuickOrderProductProperties && !window.validateQuickOrderProductProperties()) {
      return;
    }

    // Show loading state on sticky button immediately
    stickyButton.disabled = true;
    stickyButton.classList.add('loading');
    const stickySpinner = stickyButton.querySelector('.loading__spinner');
    if (stickySpinner) {
      stickySpinner.classList.remove('hidden');
    }

    if (mainAddToCartButton) {
      // Scroll to the main button first for better UX
      mainAddToCartButton.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Small delay before clicking to allow scroll
      setTimeout(() => {
        mainAddToCartButton.click();
      }, 300);
    } else {
      // Fallback: Submit the product form directly
      const productForm = document.querySelector('form[action*="/cart/add"]');
      if (productForm) {
        productForm.submit();
      } else {
        // Deep fallback
        console.error("No product form found for Sticky ATC");
        stickyButton.disabled = false;
        stickyButton.classList.remove('loading');
      }
    }
  });

  // Update button state based on main button state
  function syncButtonState() {
    const stickySpinner = stickyButton.querySelector('.loading__spinner');

    if (!mainAddToCartButton) return;

    if (mainAddToCartButton.disabled) {
      stickyButton.disabled = true;
      stickyButton.classList.add('loading');
      if (stickySpinner) {
        stickySpinner.classList.remove('hidden');
      }
    } else {
      stickyButton.disabled = false;
      stickyButton.classList.remove('loading');
      if (stickySpinner) {
        stickySpinner.classList.add('hidden');
      }
    }
  }

  // Initial sync
  syncButtonState();

  // Watch for changes to main button's disabled state
  const buttonStateObserver = new MutationObserver(syncButtonState);
  buttonStateObserver.observe(mainAddToCartButton, {
    attributes: true,
    attributeFilter: ['disabled', 'class']
  });

  // SAFETY: Watch sticky button for stuck loading state
  // If sticky is loading but main button is NOT disabled, force reset
  const stickySafetyObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'class' && stickyButton.classList.contains('loading')) {
        if (!mainAddToCartButton.disabled) {
          // If main button is enabled, sticky should NOT be loading
          // Use a small timeout to allow for transient states (like the 300ms click delay)
          setTimeout(() => {
            if (!mainAddToCartButton.disabled && stickyButton.classList.contains('loading')) {
              stickyButton.disabled = false;
              stickyButton.classList.remove('loading');
              const stickySpinner = stickyButton.querySelector('.loading__spinner');
              if (stickySpinner) stickySpinner.classList.add('hidden');
            }
          }, 500);
        }
      }
    });
  });

  stickySafetyObserver.observe(stickyButton, {
    attributes: true,
    attributeFilter: ['class']
  });
});

// Handle browser back/forward buttons
window.addEventListener('popstate', function (event) {
  // When user clicks back/forward, reload the page to show correct variant
  // Alternative: Use AJAX to switch variant based on URL
  const newUrl = window.location.pathname;

  // Check if VariantSwitcher is available
  if (window.VariantSwitcher && event.state && event.state.variantId) {
    // We have variant state, reload to ensure everything is correct
    window.location.reload();
  } else {
    // No state stored, just reload
    window.location.reload();
  }
});

// Final price update after page fully loads
window.addEventListener('load', function () {
  // Do a final price update after everything is loaded
  // This catches any URL parameters that were restored
  const urlParams = new URLSearchParams(window.location.search);
  if ((urlParams.get('express') === '1' || urlParams.get('gift_message') === '1') && window.updateAllPrices) {
    setTimeout(() => {
      window.updateAllPrices();
    }, 500);
  }
});


// Theme Editor Support for Sticky ATC Bar
document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.getElementById('sticky-atc-bar');
  if (!stickyBar) return;

  // Listen for block selection in Theme Editor
  document.addEventListener('shopify:block:select', function (event) {
    const isStickyBlock = event.detail.blockId.includes('sticky_atc');
    // Also check if the selected element is inside our sticky bar (just in case)
    const isInsideSticky = stickyBar.contains(event.target);

    if (isStickyBlock || isInsideSticky) {
      stickyBar.classList.remove('hidden');
      stickyBar.classList.add('visible');
    }
  });

  // Listen for block deselection
  document.addEventListener('shopify:block:deselect', function (event) {
    const isStickyBlock = event.detail.blockId.includes('sticky_atc');
    const isInsideSticky = stickyBar.contains(event.target);

    if (isStickyBlock || isInsideSticky) {
      const mainAddToCart = document.querySelector('button[type="submit"][name="add"]');
      if (mainAddToCart) {
        const rect = mainAddToCart.getBoundingClientRect();
        if (rect.bottom > 0) {
          stickyBar.classList.remove('visible');
          stickyBar.classList.add('hidden');
        }
      } else {
        stickyBar.classList.remove('visible');
        stickyBar.classList.add('hidden');
      }
    }
  });
});
